import { useApplicationField } from '../useApplicationField';

// ─── Principal (read-only — pre-filled from auth) ─────────────────────────────

export const useBorrowerPrincipalFirstName = () =>
    useApplicationField((d) => d.information.borrower.principal.name.first, (d) => d);

export const useBorrowerPrincipalMiddleName = () =>
    useApplicationField((d) => d.information.borrower.principal.name.middle ?? '', (d) => d);

export const useBorrowerPrincipalLastName = () =>
    useApplicationField((d) => d.information.borrower.principal.name.last, (d) => d);

export const useBorrowerPrincipalPhone = () =>
    useApplicationField((d) => d.information.borrower.principal.phone, (d) => d);

export const useBorrowerPrincipalEmail = () =>
    useApplicationField((d) => d.information?.borrower?.principal?.email ?? '', (d) => d);
